import axios from 'axios'
// <script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
// <script type="text/javascript" src="https://res2.wx.qq.com/open/js/jweixin-1.6.0.js"></script>

// 检测是不是微信
const isWeixin = /micromessenger/ig.test(navigator.userAgent)

// 设置成功的回调函数
const successHandler = function () {
  // 分享成功，触发dplus统计
  // console.log('wx share success handler.');
}

// 微信分享的数据
const shareData = {}

// 微信分享初始化
// 分享的数据，还有wxBridge Ready的回调
function initShare (data, callback) {
  if (!isWeixin || document.getElementById('wxShare') !== null) {
    // 不是微信环境的话，不做任何处理
    return null
  }

  const script = document.createElement('script')
  script.id = 'wxShare'
  script.src = 'https://res.wx.qq.com/open/js/jweixin-1.4.0.js'
  script.addEventListener('load', () => {
    // 初始化微信分享
    console.log('====>wxShare init.')

    // console.log('window.location.href: ', window.location.href)
    // const url = window.location.href.split('#')[0]
    // console.log('url: ', url)
    const url = window.location.href
    Object.assign(shareData, {
      wxUrl: 'https://share.m.china.com.cn/doCheck?url=' + encodeURIComponent(url),
      title: data.title || document.getElementsByTagName('title')[0].innerText,
      desc: data.desc || document.getElementsByName('description')[0].getAttribute('content'),
      imgUrl: data.image || 'https://m.china.com.cn/images/app/appicon.png',
      link: data.url
    })

    axios.get(shareData.wxUrl)
      .then(function (response) {
        // 拿到验证的数据了，配置config
        const data = response.data

        window.wx.config({
          debug: false, // true
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ['checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData']
        })

        window.wx.ready(function () {
          console.log('====>wx config done, wx ready.')

          if(callback && typeof callback === 'function') callback()

          // 1 判断当前版本是否支持指定 JS 接口，支持批量判断
          window.wx.checkJsApi({
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData'
            ],
            success: function (res) {
              console.log('====>wx checkJsApi success.')

              // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
              window.wx.updateAppMessageShareData({
                title: shareData.title, // 分享标题
                desc: shareData.desc, // 分享描述
                link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareData.imgUrl, // 分享图标
                success: successHandler
              })

              // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
              window.wx.updateTimelineShareData({
                title: shareData.title, // 分享标题
                link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareData.imgUrl, // 分享图标
                success: successHandler
              })
            }
          })
        })

        window.wx.error(function (res, error) {
          console.log(res, error)
        })
      })
      .catch(function (xhr) {
        console.error(xhr)
      })
  })

  // 加载js
  document.body.appendChild(script)
}

// 修改微信分享的数据
function updateShare (data, callback) {
  // 将新的分享数据和旧的合并，覆盖旧的数据，然后设置到微信分享里
  Object.assign(shareData, data)

  document.getElementsByTagName('title')[0].innerText = shareData.title
  document.getElementsByName('description')[0].setAttribute('content', shareData.desc)

  // 不是微信环境的话，不做任何处理
  // 如果没有wx对象的话，也不做处理
  if (!isWeixin || !window.wx) return null

  // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
  window.wx.updateAppMessageShareData({
    title: shareData.title, // 分享标题
    desc: shareData.desc, // 分享描述
    link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: shareData.imgUrl, // 分享图标
    success: function(){
      successHandler()
      if(typeof callback === 'function') callback()
    }
  })

  // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
  window.wx.updateTimelineShareData({
    title: shareData.title, // 分享标题
    link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: shareData.imgUrl, // 分享图标
    success: function(){
      successHandler()
      if(typeof callback === 'function') callback()
    }
  })
}

export {
  initShare,
  updateShare
}
